import React from "react";

import moment from "moment";
import { useEffect, useState } from "react";

import Counter from "./Counter";

import styles from './Countdown.module.scss';


const WEDDING_DAY = "06 jun 2026 17:00:00 +0200";

const Countdown = ({className}) => {
    const [currentTime, setCurrentTime] = useState(moment());
    const timeBetween = moment.duration(moment(WEDDING_DAY).diff(currentTime));
  
    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentTime(moment());
      }, 1000);
  
      return () => clearInterval(interval);
    }, []);

    const countdown = {
        years: timeBetween.years(),
        months: timeBetween.months(),
        days: timeBetween.days(),
        hours: timeBetween.hours(),
        minutes: timeBetween.minutes(),
        seconds: timeBetween.seconds()
    }
  
    return (
      <>
        <div className={styles.tag}>
            <p>06.06.2026г. <span className={styles.heartIcon}>♥</span> 17:00 часа</p>
        </div>
        <div className={`${styles.counterWrapper} ${className}`}>
          <div className={styles.counter}>
              {countdown.years ? <Counter number={countdown.years} text="Година" /> : undefined}
              {countdown.months ? <Counter number={countdown.months} text="Месеца" /> : undefined}
              <Counter number={countdown.days} text="Дни" />
              <Counter number={countdown.hours} text="Часа" />
              <Counter number={countdown.minutes} text="Минути" hideOnMobile={Boolean(countdown.years)} />
              <Counter number={countdown.seconds} text="Секунди" hideOnMobile={Boolean(countdown.months)} />
          </div>
        </div>
      </>
    );
}

export default Countdown;